<div #signatureWrapper class="block w-12 h-full">
  <canvas #canvas class="border-1 border-round-lg border-primary block" width="600" height="200"></canvas>
</div>

